//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"BlendRadius",0,"Expression",0],[0,"BlendSharpCorners",1,0],[0,"EndCapShape",1,0],[0,"ReverseWidthDirection",1,0],[0,"Section",1,"Section",0],[0,"Sketch",1,"Features.SketchFeature",0],[0,"Symmetric",1,0],[0,"UseSystemWidth",1,0],[1,"Width",0,"Expression",0]],[[["rip_edges"],"SetRipEdges",{},1,0],[["number_of_rip_edges"],"GetRipEdges",{R_:{rip_edges:"Edge[]"}},0,0],[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0]],[]];
SPLM.Features.SheetMetal.EdgeRipBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.EdgeRipBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.EdgeRipBuilder.EndCapShapeOptions = Object.freeze({
    "Square" : "Square", "Round" : "Round"});

export default SPLM;